import React from "react"
import { FormattedMessage, injectIntl } from "react-intl"
import { getPriceListName } from "../../name-helpers/priceListNameHelper"
import {Intl} from "../../state/helpers/IntlProps"


const BulkCreateWarningComponent = (props: {intl: Intl}) => {
    return (
        <span className="col-12 alert alert-warning">
            <small>
                <FormattedMessage
                    id="price_list.bulk.warning_description"
                    defaultMessage="No {priceList} rules will be applied during the bulk operation"
                    values={{
                        priceList: getPriceListName(props.intl)
                    }}
                />
            </small>
        </span>
    )
}


export default injectIntl(BulkCreateWarningComponent)


// WEBPACK FOOTER //
// ./src/price-list/components/BulkCreateWarningComponent.tsx